const translations = {
    TAC_TERMS_AND_CONDITIONS: {
        description: 'Terms and Conditions Title',
        primaryValue: 'TERMS AND CONDITIONS',
        stringKey: 'TAC_TERMS_AND_CONDITIONS',
    },
    TAC_ACCEPT_BUTTON: {
        description: "Accept Button Text",
        primaryValue: "ACCEPT",
        stringKey: "TAC_ACCEPT_BUTTON"
    },
    TAC_AGREE_TO_TAC: {
        description: "Agreement Text",
        primaryValue: "I have read and agree to these terms and conditions.",
        stringKey: "TAC_AGREE_TO_TAC"
    },
    TAC_AUDIENCE: {
        description: "Audience Information",
        primaryValue: "Audience: All Employees",
        stringKey: "TAC_AUDIENCE"
    },
    TAC_BY_CLICKING: {
        description: "Confirmation Text",
        primaryValue: "By clicking ACCEPT, you are confirming that you have read and understand the policy.",
        stringKey: "TAC_BY_CLICKING"
    },
    TAC_DISCOUNT_LOCATION: {
        description: "Discount Location",
        primaryValue: "Location: Southeast Asia",
        stringKey: "TAC_DISCOUNT_LOCATION"
    },
    TAC_EMPLOYEE_DISCOUNT: {
        description: "Employee Discount Title",
        primaryValue: "EMPLOYEE DISCOUNT",
        stringKey: "TAC_EMPLOYEE_DISCOUNT"
    },
    TAC_PLEASE_READ: {
        description: "Instruction to Read Terms",
        primaryValue: "Please read and agree to these terms in order to use Pass Play.",
        stringKey: "TAC_PLEASE_READ"
    },
    TAC_POST_TO: {
        description: "Post Location",
        primaryValue: "Post to: PAY AND BENEFITS> Employee discounts",
        stringKey: "TAC_POST_TO"
    },
    TAC_READ_ENTIRE: {
        description: "Instruction to Read Entire Content",
        primaryValue: "Please read entire content before agreeing to the policy.",
        stringKey: "TAC_READ_ENTIRE"
    },
    TAC_STORE_REGISTRATION: {
        description: "Store Registration Title",
        primaryValue: "Nike HR Employee Store Registration",
        stringKey: "TAC_STORE_REGISTRATION"
    }
};

export default translations;